interface SplitReadMore {
  intro: string;
  readMore?: string;
}

const splitReadMore = (bodyRaw: string): SplitReadMore => {
  // Splits CKEditor body HTML on the readmore wrapper div inserted by the
  // readmore plugin, e.g. <div class="ckeditor-readmore-wrapper ...">...</div>
  const match = bodyRaw.match(/^(.*?)(<div class="ckeditor-readmore-wrapper[^"]*"[^>]*>.*)$/s);

  if (!match) {
    return { intro: bodyRaw };
  }

  const [, intro, readMore] = match;

  return { intro: intro ?? '', readMore };
};

export default splitReadMore;
